import { createFileRoute } from '@tanstack/react-router'

// All analytics search params (interval, period navigation, comparison, channel filters) live on the
// index page route so URLs stay `?interval=&periodStart=&…`.
export const Route = createFileRoute('/_authenticated/_general/analytics')({
	staticData: {
		crumb: ({ context: { L } }) => L.Analytics.Title()
	}
})
